<template>
 <!-- Modal -->
  <div class="content-box-gray card modal fade" id="display-kss-tracker-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
<!-- <div v-if="milestoneAchieved" class="overlay"> -->
    <div v-if="milestoneAchieved" id="yayOverlay" class="overlay" >
        <h5>Yay, you've achieved a Milestone: {{ attempt_count }} consecutive days!</h5>
        <img src="/images/yays/rugby-yay.gif" >
    </div>
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header title text-center">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
         <h6 class="modal-title" id="myModalLabel" v-html="'Focus on your Strategy for your <em><u>' + currentKSSdata.name + '</em> Goal</u>'" ></h6>
        </div>
        <div class=" content modal-body">
<!--Start-->
<div class="content-box-gray card" >
                                    <!-- <div class="title text-center">
                                        <h5 class="mt-2" style="margin:auto;" >Focus on your Self-Sabotage Analysis &amp; Strategy:</h5>
                                    </div> -->
                                    <div class="goal-head" >
                                        <b>My Goal:</b> {{goal_kss_name}}<br/> <b>My Why: </b>{{ goal_kss_desc }}
<br/><span style="font-size:small;color:rgb(253, 253, 253);"><b>Review Time: {{ elapsedTime }}  seconds.</b><br/>(Need to spend {{elapsedTimeTarget}} seconds)</span>
                                    </div>
 <div class="card p-2 m-2" >
                                    <div class="periods-head">Me: stuck with my Past-Self</div>
                                    <div class="row justify-content-between" >
                                        <div class="col-4">
                                             <h6  class="component-head txt-primary bg-secondary">Goal-Defeating<br/> Actions/Inactions </h6>
                                            <div>
                                                <ul>
                                                    <li v-for="(action, index) in past_actions" :key="index" >
                                                        {{action}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                             <h6 class="component-head txt-primary bg-secondary">Hidden Committments<br/> to my Past-Self</h6>
                                             <div>
                                                <ul>
                                                    <li v-for="(committment, index) in past_committments" :key="index" >
                                                        {{committment}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                             <h6 class="component-head txt-primary bg-secondary">Limiting <br/>Beliefs/Assumptions</h6>
                                            <div>
                                                <ul>
                                                    <li v-for="(belief, index) in past_beliefs" :key="index" >
                                                        {{belief}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
</div>
                                    <div class="card p-2 m-2" >
                                    <div class="periods-head">Me: aligned with my Future-Self</div>
                                    <div class="row justify-content-between" >
                                        <div class="col-4">
                                             <h6  class="component-head txt-primary bg-secondary">Goal-Supporting<br/> Actions/Inactions </h6>
                                            <div>
                                                <ul>
                                                    <li v-for="(action, index) in new_actions" :key="index" >
                                                        {{action}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                             <h6 class="component-head txt-primary bg-secondary">New Committments<br/> to my Future-Self</h6>
                                             <div>
                                                <ul>
                                                    <li v-for="(committment, index) in new_committments" :key="index" >
                                                        {{committment}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                             <h6 class="component-head txt-primary bg-secondary">Empowering <br/>Beliefs/Assumptions</h6>
                                            <div>
                                                <ul>
                                                    <li v-for="(belief, index) in new_beliefs" :key="index" >
                                                        {{belief}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
</div>
                                </div>
<!--End-->

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '../../../event-bus';
import axios from 'axios';
import Errors from '../../partials/Errors.vue';
import Swal from 'sweetalert2';
// var _ = require('lodash');

export default {
    components: { Errors,
    },
    name: "KillSelfSabotageTrakkerModal",
    data() {
        return {
            currentKSSdata:[],
            // remainingComponents:[],
            kssCommittmentsData: '',
            kssActionsData: '',
            kssBeliefsData: '',
            savedPerformance: false,
            milestoneAchieved : false,
            attempt_count: 0,
            message:'',
            past_actions:[],
            past_committments:[],
            past_beliefs:[],
            new_actions:[],
            new_committments:[],
            new_beliefs:[],
            goal_kss_name:'',
            goal_kss_desc:'',
            elapsedTimeTarget: 90,
            elapsedTime:0,
            startTime:'',
            timerInterval:'',
            userdata:'',

        }
    },
    props: {
    },
    mounted() {
        EventBus.$on('displayKSSTrackerModal', (data) => {
            console.log("In KSSTrackerModal: ");
            this.currentKSSdata = data.kssdata;
            this.goal_kss_name = this.currentKSSdata.name;
            this.goal_kss_desc = this.currentKSSdata.description;
            // console.log(this.currentKSSdata);
            this.kssCommittmentsData = this.currentKSSdata.committments;
            this.kssBeliefsData = this.currentKSSdata.beliefs;
            this.kssActionsData = this.currentKSSdata.actions;
            this.splitDataIntoFormerNew();
            // this.getArrayFromDescription('FORMER');
             this.userdata = data.userdata;
            this.startTime = new Date();
            this.startTimer();
console.log("displayKSSTrackerModal mounted");
            $('div#display-kss-tracker-modal').modal('show');

        });
    },
    beforeDestroy() {
    this.stopTimer();
    },
    methods: {
        getArrayFromDescription(componentArr, FORMER_or_NEW){
            var arr = [];
            var descArr = [];
            componentArr.forEach((obj) => {
                if(obj.type == FORMER_or_NEW) {
                    descArr = JSON.parse(obj.description);
                    // console.log(obj.type);
                    for (var i = 0; i < descArr.length; i++) {
                        var entry = descArr[i];
                        // console.log(entry);
                        arr.push(entry);
                    }
                }
            });
        return arr;
        },
        splitDataIntoFormerNew(){
            this.past_actions = this.getArrayFromDescription(this.kssActionsData, 'FORMER');
            this.new_actions = this.getArrayFromDescription(this.kssActionsData, 'NEW');
            this.past_committments = this.getArrayFromDescription(this.kssCommittmentsData, 'FORMER');
            this.new_committments = this.getArrayFromDescription(this.kssCommittmentsData, 'NEW');
            this.past_beliefs = this.getArrayFromDescription(this.kssBeliefsData, 'FORMER');
            this.new_beliefs = this.getArrayFromDescription(this.kssBeliefsData, 'NEW');
        },
        cancel() {
            this.milestoneAchieved = false; //shut down redisplay of yay (if triggered) and if this modal is re-displayed.
            this.message = '';
            this.currentkssdata = '';
            this.actionhabitcomponents = '';
            this.remainingComponents = '';
            this.savedPerformance= false;
            $('div#display-kss-trakker-modal').modal('hide');
        },


        startTimer() {
            this.timerInterval = setInterval(() => {
                const currentTime = new Date();
                this.elapsedTime = Math.floor(
                    (currentTime - this.startTime) / 1000
                );
            }, 1000);
            console.error(this.elapsedTime);
            if(this.elapsedTime >= this.elapsedTimeTarget) {
                console.error('Review  time achieved for ' + this.userinfo.id);
                this.recordKSSReview();
                this.reviewMessage ="Great job!";
                this.stopTimer();
            }
        },
        stopTimer() {
            clearInterval(this.timerInterval);
        },
        recordKSSReview() {
            console.error('Recording review for ' + this.userdata.id);
             axios.post('/eliminatess/review/save', {
                user_id:this.userdata.id,
                kill_selfsabotage_id:this.currentKSSdata.id
            })
            .then(res => {
                this.reviewMessage = res.data.message;
                this.stopTimer();
                console.error(res.data.message);
            })
            .catch(err => {               ;
                console.error(err);
            })
            .finally(()=> {
                  this.updateToast(this.reviewMessage, 4000);
            });
        },

        savePerformance() {
            if(this.remainingComponents.length==0) {
            let incomingdata = '';
                console.error("Saving Done on kill_selfsabotage_id: user_id: " + this.userdata.id + ", KSS_ID: " + this.currentKSSdata.id);
                axios.post('/eliminatess/tracking/update', {
                    user_id:this.userdata.id,
                    kill_selfsabotage_id: this.currentKSSdata.id,
                })
                .then(res => {
                    this.loading = false;
                    this.success = true;
                    this.message = res.data.message;
                    this.attempt_count = res.data.attempt_count;
                    this.milestoneAchieved = (res.data.attempt_count % 10 === 0);
                    this.attempt_count = res.data.attempt_count;
                    this.failure = false;

                })
                .catch(err => {
                    this.loading = false;
                    this.failure = true;
                    this.success = false;
                })
                .finally(() => {
                        //  console.error('In delete finally.....');
                        // console.error(incomingdata);
                        this.disableRecordPerfButton();
                        // this.informChart();
                        this.$forceUpdate();
                });
            } else {
                console.error ("Check... this button should not have been clickable")

            }
        },
        startTracking(habit_id) {
        },



        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },
    },
  watch: {
        elapsedTime(newValue) {
            if (newValue === this.elapsedTimeTarget) {
            this.recordKSSReview();
            }
        }
    },
}
</script>

<style scoped>
.content-box-gray .content {
    overflow: wrap;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
     background:#1a794b;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}


.overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: fadeOut 5s forwards;
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}

#yayOverlay {
  width: 40vw;
  height: 40vh;
  border: 2px solid #000;
  border-radius: 4px;
  box-shadow: #555 4px 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

}

#yayOverlay.h5 {
  max-width: 100%;
  margin: 0;
  padding: 10px;
  word-wrap: break-word;
}
#yayOverlay.img {
  max-width: 100%;
  max-height: 80%;
  object-fit: contain;
}

@media (max-width: 768px) {
    #yayOverlay.card {
        width: 80vw;
        height: 60vh;
        /* Adjust dimensions and other styles for mobile */
    }
    #yayOverlay.img {
    width: 80%;
    object-fit: contain;
    }
}
.goal-head{
background: #212c3e;
color: #d6a30a;
font-size:small;
text-align:center;
word-wrap: break-word;
  @media (max-width: 768px) {
       font-size:small;
    }
}
.periods-head{
background: #d6a30a;
color: #0f0f0f;
font-size:small;
text-align:center;
word-wrap: break-word;
  @media (max-width: 768px) {
       font-size:small;
    }
}
.component-head{
background: #687b9a;
color: #2003fc;
font-size:small;
text-align:center;
word-wrap: break-word;
  @media (max-width: 768px) {
       font-size:small;
    }
}

ul{
list-style-type: none; /* Remove bullets */
  padding: 0; /* Remove padding */
  margin: 0; /* Remove margins */
    text-align: left;
    font-size: small;
}
.card{
    border:#111 1px solid;
}

</style>
